import { useState } from 'react';

interface PitchedItemIconProps {
  slug: string;
  name: string;
}

/** Icons render at 32px everywhere — matches the 32x32 assets in public/pitched/ (denser rows than the 48px boss tiles). */
const SIZE_PX = 32;
const SIZE_CLASS = 'size-8';

/**
 * Same-origin Pitched/Brilliant item icon (see `frontend/scripts/fetch-pitched-icons.mjs` for how
 * `public/pitched/<slug>.png` gets populated — 32x32 equip icons from the MapleStory Wiki).
 * Falls back to a letter tile — same footprint, no layout shift — for any item the fetch script
 * has no art for, or if the file 404s for any other reason. Mirrors `BossIcon`'s idiom (REV2).
 * Decorative: the item name is always adjacent text, so `alt=""`.
 */
export function PitchedItemIcon({ slug, name }: PitchedItemIconProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    const initial = name.trim().charAt(0).toUpperCase() || '?';
    return (
      <span
        aria-hidden="true"
        className={[
          SIZE_CLASS,
          'flex shrink-0 items-center justify-center rounded-lg bg-bg-elevated-hover font-display text-sm font-semibold text-text-faint',
        ].join(' ')}
      >
        {initial}
      </span>
    );
  }

  return (
    <img
      src={`/pitched/${slug}.png`}
      alt=""
      loading="lazy"
      width={SIZE_PX}
      height={SIZE_PX}
      className={[SIZE_CLASS, 'shrink-0 rounded-lg bg-bg-elevated-hover object-contain'].join(' ')}
      onError={() => setFailed(true)}
    />
  );
}
